import { FormControl, MenuItem } from '@mui/material';
import { useMemo, memo } from 'react';
import { getReportsFilterPeriodsHome } from 'constants/config';
import { t } from 'i18next';
import SearchableSelect from 'components/Forms/searchable/SearchableSelect';

const ReportsFilter = ({ query, onSelect }) => {
  const { period } = query;
  const periods = useMemo(() => getReportsFilterPeriodsHome(), []);
  const currentPeriod = useMemo(() => periods[period] || periods.week, [period, periods]);

  return (
    <FormControl sx={{ minWidth: '170px' }}>
      <SearchableSelect variant="outlined" value={currentPeriod.label} size="small">
        {Object.keys(periods).map((key) => (
          <MenuItem value={periods[key].label} key={key} onClick={() => onSelect('period', key)}>
            {t(periods[key].label)}
          </MenuItem>
        ))}
      </SearchableSelect>
    </FormControl>
  );
};
export default memo(ReportsFilter);
